import React, { useEffect, useState } from 'react';
import { FiLogOut } from 'react-icons/fi';
import { useParams, useNavigate } from 'react-router-dom';
import ArtPicker, { CATEGORIES } from '../../comps/ArtPicker';
import Header from '../../comps/header';
import AssignLactors from './assign-lactors';
import AutoMailer from './autoMailer';
import DatesManagment from './dates_managment';
import Requests from './requests';
import UsersController from './user_managment';
import PandaDoc from './panda_doc';
import Archive from './archive';
import FormBuilderContainer from './formBuilder';
import MainPage from './formBuilder/mainPage';
import Winners from './winners';
import { GET } from '../../API';

export default function AdminController() {
  const { route, category } = useParams();
  const [Routes, setRoutes] = useState([]);
  const token = localStorage.getItem('token');

  const GoTo = useNavigate();

  // temporary restrict the access of navigation to these 2 admins
  const isRestricted = async () => {
    try {
      const response = await GET('users/me');
      const user = await response.json();
      
      return (
        user.mobile === '0544991315' ||
        user.mobile === '0523337073' ||
        user.mobile === '0528454074'
      );
    } catch (error) {
      console.warn('error while getting temp user', error);
    }
  };

  useEffect(() => {
    if (!category) return;

    setColor(category);

    const fetchUserAndSetRoutes = async () => {
      const restricted = await isRestricted();

      const routes = [
        {
          name: <FiLogOut />,
          link: `/logout/${token}`,
        },
        {
          name: 'בקשות מימון',
          link: `/${category}/requests`,
        },
        {
          name: 'עבור לתחום',
          options: [
            { name: 'קולנוע', link: '/film' },
            { name: 'אמנויות', link: '/art' },
            { name: 'אמנים במצוקה', link: '/help' },
            { name: 'סיוע להוצאה לאור של ספרים', link: '/publish' },
          ],
        },
      ];

      if (!restricted) {
        routes.push(
          {
            name: 'טפסים',
            link: `/${category}/forms`,
          },
          {
            name: 'צור טופס',
            link: `/${category}/form-builder`,
          },
          {
            name: 'הקצאת לקטורים',
            link: `/${category}/assign-lactors`,
          },
          {
            name: 'ניהול תאריכים',
            link: `/${category}/dates-managment`,
          },
          {
            name: 'משתמשים',
            link: `/${category}/users`,
          },
          {
            name: 'נוסח דוא"ל',
            link: `/${category}/auto-mailer`,
          },
          {
            name: 'ארכיון',
            link: `/${category}/archive`,
          },
          {
            name: 'ניהול זוכים',
            link: `/${category}/winners`,
          }
        );
      }

      setRoutes(routes);
    };

    fetchUserAndSetRoutes();
  }, [category]);

  /* useEffect(() => {
    if (!category) return;

    setColor(category);

    setRoutes([
      {
        name: <FiLogOut />,
        link: `/logout/${token}`,
      },
      {
        name: 'בקשות מימון',
        link: `/${category}/requests`,
      },
      {
        name: 'הקצאת לקטורים',
        link: `/${category}/assign-lactors`,
      },
      {
        name: 'ניהול תאריכים',
        link: `/${category}/dates-managment`,
      },
      {
        name: 'משתמשים',
        link: `/${category}/users`,
      },
      {
        name: 'נוסח דוא"ל',
        link: `/${category}/auto-mailer`,
      },
      {
        name: 'ארכיון',
        link: `/${category}/archive`,
      },
      {
        name: 'עבור לתחום',
        options: [
          {
            name: 'קולנוע',
            link: '/film',
          },
          {
            name: 'אמנויות',
            link: '/art',
          },
          {
            name: 'אמנים במצוקה',
            link: '/help',
          },
          {
            name: 'סיוע להוצאה לאור של ספרים',
            link: '/publish',
          },
        ],
      },
      {
        name: 'צור טופס',
        link: `/${category}/form-builder`,
      },
      {
        name: 'טפסים',
        link: `/${category}/forms`,
      },
    ]);
  }, [category]); */

  //colors..
  const setColor = (cat) => {
    CATEGORIES.forEach((item) => {
      if (item.type === cat) {
        document
          .querySelector(':root')
          .style.setProperty('--primary', item.color);
      }
    });
  };

  if (!category) return <ArtPicker />;

  if (!CATEGORIES.some((cat) => cat.type === category))
    return (window.location.href = '/');
  return (
    <>
      <Header links={Routes} />
      <main style={{ marginTop: '70px' }}>
        {route === 'requests' ? (
          <Requests />
        ) : route === 'assign-lactors' ? (
          <AssignLactors />
        ) : route === 'dates-managment' ? (
          <DatesManagment />
        ) : route === 'users' ? (
          <UsersController />
        ) : route === 'auto-mailer' ? (
          <AutoMailer />
        ) : route === 'panda-doc' ? (
          <PandaDoc />
        ) : route === 'archive' ? (
          <Archive />
        ) : route === 'form-builder' ? (
          <FormBuilderContainer />
        ) : route === 'forms' ? (
          <MainPage />
        ) : route === 'winners' ? (
          <Winners />
        ) : (
          // change the user route to requests
          GoTo(`/${category}/requests`)
        )}
      </main>
    </>
  );
}
